import clsx from 'clsx';
import { formFieldStyles } from '@v2/styles/formFieldStyles';

export const styles = {
  ...formFieldStyles,

  base: clsx(
    formFieldStyles.base,
    'tw-placeholder-neutral-400 tw-appearance-none',
    'tw-outline-none [box-shadow:none_!important]'
  ),

  iconContainer: clsx(
    'tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center',
    'tw-pointer-events-none'
  ),

  withIconPadding: 'tw-pl-9 tw-pr-3 tw-py-2',

  defaultPadding: 'tw-px-3 tw-py-2',
};
